<template>
  <div>
    <div class="ll-list-with-button">
      <div class="title">
        {{ title }}
      </div>
      <div
        v-if="time"
        class="time"
      >
        <WsTextChip001
          leading-icon="icon-time"
          :text-label="time"
          gray
          icon-lg
          font-size-sm
        />
      </div>
      <LlAvatar
        v-if="avatar.id"
        :text-label="avatar.name"
        :circle-size="22"
        :image="avatar.avatar"
      />
      <div class="btn">
        <WsButton001
          width-stretch
          :to="to"
        >
          {{ btnText }}
        </WsButton001>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  name: "LlBoardChecklistListItem",
  props: {
    title: {
      type: String,
      default: "",
    },
    time: {
      type: String,
      default: "",
    },
    avatar: {
      type: Object,
      default() {
        return {};
      },
    },
    btnText: {
      type: String,
      default: "",
    },
    to: {
      type: String,
      default: "",
    },
  },
  methods: {
    onClick() {
      this.$emit("click");
    },
  },
};
</script>
<style lang="scss" scoped>
.ll-list-with-button {
  @include flex_align;
  padding: 10px 19px 10px 20px;
  border-bottom: 1px solid var(--blue-30);
  &.title {
    padding: 15px 19px 15px 20px;
  }
  .title {
    padding-right: 20px;
    width: 240px;
    font-size: 0.875rem;
    line-height: 1.43;
    letter-spacing: 1px;
    color: var(--gray-900);
    &.time {
      width: 114px;
    }
  }
  .time {
    width: 114px;
  }
  .ll-avatar {
    @include auto_margin_left(20px);
  }
  .btn {
    margin-left: auto;
    width: 140px;
  }
}
</style>